import React, { createContext, useRef, useState } from "react";
import NotificationAlert from "react-notification-alert";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const notificationRef = useRef(null);
  const [notificationOpen, setNotificationOpen] = useState(false);

  const notify = (type, message) => {
    if (notificationOpen) return;

    setNotificationOpen(true);

    notificationRef.current.notificationAlert({
      place: "tc",
      icon: "ni ni-bell-55",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {message}
          </span>
        </div>
      ),
      type,
      autoDismiss: 5,
    });

    setTimeout(() => setNotificationOpen(false), 5000);
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationRef} />
      </div>
      {children}
    </NotificationContext.Provider>
  );
};